export default {
  overview: {
    loading: false,
    lastUpdate: {},
    data: {},
  },
  // Meses de competência com valores agregados (lista do modal de seleção).
  // `data` é a lista crua do backend; `lastUpdate` habilita o cache por tempo.
  meses: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  // Integração BTG (wallet-fee): `disponivel` (null = ainda não consultado),
  // `conexao` (último resultado de GET btg/conexao) e `operacoes` chaveadas por
  // data_referencia (lista de operações do mês, mais recentes primeiro).
  btg: {
    disponivel: null,
    estornoHabilitado: false,
    conexao: null,
    operacoes: {},
    // Spec 05: saldo em conta BTG por id_cliente (GET btg/saldos) + quando foi lido.
    // Vazio = não consultado (a tabela não mostra a sub-linha).
    saldos: {},
    saldosConsultadoEm: null,
  },
  // {{NEXT}}
}
